<img [src]="product?.colorsWithImages[0].images[0]" />
<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="fields-wrapper">
    <app-text-field
      ngDefaultControl
      formControlName="title"
      label="Title"
      placeholder="Enter title"
      [value]="formControls.title.value"
      [errorMessage]="errorMessages.title"
    ></app-text-field>
    <app-text-field
      ngDefaultControl
      formControlName="subtitle"
      label="Subtitle"
      placeholder="Enter subtitle"
      [value]="formControls.subtitle.value"
      [errorMessage]="errorMessages.subtitle"
    ></app-text-field>
  </div>
  <div class="fields-wrapper">
    <app-text-field
      ngDefaultControl
      formControlName="price"
      label="Price"
      placeholder="Enter price"
      type="number"
      [value]="formControls.price.value"
      [errorMessage]="errorMessages.price"
    ></app-text-field>
    <app-text-field
      ngDefaultControl
      formControlName="previousPrice"
      label="Previous price"
      type="number"
      [value]="formControls.previousPrice.value"
      [errorMessage]="errorMessages.previousPrice"
    ></app-text-field>
  </div>
  <div class="fields-wrapper">
    <app-select
      ngDefaultControl
      formControlName="sizesType"
      label="Sizes type"
      placeholder="Choose type"
      [value]="formControls.sizesType.value"
      [options]="getSizesTypeOptions()"
      color="secondary"
      [errorMessage]="errorMessages.sizesType"
      (optionSelected)="onOptionSelect(formControls.sizesType, $event, formControls.sizes)"
    ></app-select>
    <app-select
      label="Sizes"
      placeholder="Choose sizes"
      [multipleValue]="formControls.sizes.value"
      [options]="getSizeOptions()"
      color="secondary"
      [multiple]="true"
      [errorMessage]="errorMessages.sizes"
      (optionSelected)="onOptionSelect(formControls.sizes, $event)"
    ></app-select>
  </div>
  <div class="fields-wrapper">
    <app-select
      label="Categories"
      placeholder="Choose categories"
      [multipleValue]="formControls.categories.value"
      [options]="getCategoryOptions()"
      color="secondary"
      [multiple]="true"
      [errorMessage]="errorMessages.categories"
      (optionSelected)="onOptionSelect(formControls.categories, $event, formControls.subcategories)"
    ></app-select>
    <app-select
      label="Subcategories"
      placeholder="Choose subcategories"
      [multipleValue]="formControls.subcategories.value"
      [options]="getSubcategoryOptions()"
      color="secondary"
      [multiple]="true"
      [errorMessage]="errorMessages.subcategories"
      (optionSelected)="onOptionSelect(formControls.subcategories, $event)"
    ></app-select>
  </div>
  <div class="fields-wrapper" *ngIf="showOtherCategoryInput() || showOtherSubcategoryInput()">
    <app-text-field
      #otherCategory
      *ngIf="showOtherCategoryInput()"
      ngDefaultControl
      formControlName="otherCategory"
      placeholder="Set categories.."
      [errorMessage]="errorMessages.otherCategory"
    ></app-text-field>
    <app-text-field
      #otherSubcategory
      *ngIf="showOtherSubcategoryInput()"
      ngDefaultControl
      formControlName="otherSubcategory"
      placeholder="Set subcategories.."
      [errorMessage]="errorMessages.otherSubcategory"
    ></app-text-field>
  </div>
  <app-edit-colors-with-images
    #editColorWithImages
    [colorsWithImages]="product?.colorsWithImages || []"
    [defaultColorIndex]="product?.defaultColorIndex"
  >
  </app-edit-colors-with-images>
  <div class="buttons-wrapper">
    <app-button size="lg" type="submit">Save</app-button>
    <app-button *ngIf="product" size="lg" color="secondary" (click)="onRemove()">Remove</app-button>
  </div>
</form>
